var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topBar",class:_vm.$isMobile ? 'topBar--mobile' : '',style:(_vm.nextMatchDateTimeMS < 0 ? 'background-color: white;' : '')},[_c('CalendarTimer',{attrs:{"shrinkedView":_vm.shrinkedView,"bookingOrViewing":true,"topBarView":true}}),(_vm.nextMatchDateTimeMS < 0)?_c('NoBookings',{attrs:{"topBarView":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }